<template>
  <button
    type="button"
    :class="`btn ${fullWidth?'w-100':'', hasUnresolvedDependencies?'btn_disabled':'' , addClass} col-lg-${grid.columns}`"
    :style="cssString"
    :disabled="disabled || loading || hasUnresolvedDependencies"
    @click="clicked"
    @keypress.enter="clicked"
  >
    <div class="btn-text" :style="textCssString" v-if="!loading">
      <svg v-if="addClass.includes('btn-back')" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-left mr-2 pb-1" viewBox="0 0 16 16">
        <path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/>
      </svg>
      {{ $t(text) }}
    </div>
    <div
      v-else
      class="spinner-border spinner-border-sm"
      :style="textCssString"
      role="status"
    >
      <span class="sr-only">Loading...</span>
    </div>
  </button>
</template>

<script>
export default {
  name: "button-component",
  data () {
    return {
      loading: false,
      cssString: "",
      textCssString: ""
    };
  },
  props: {
    requires: {
      type: Array
    },
    grid: {
      type: Object,
      required: false,
      default: () => {}
    },
    backgroundColor: {
      type: String,
      required: false,
      default: "#000"
    },
    borderColor: {
      type: String,
      required: false,
      default: "#000"
    },
    textColor: {
      required: false,
      type: String,
      default: "#fff"
    },
    text: {
      required: false,
      type: String,
      default: "Button"
    },
    borderRadius: {
      required: false,
      type: String,
      default: "0"
    },
    disabled: {
      required: false,
      type: Boolean,
      default: false
    },
    enabledOn:{
      required: false,
      type:String,
      default:''
    },
    fullWidth: {
      type: Boolean
    },
    action: {
      type: [Object, Array]
    },
    styles: {
      type: Object,
      default: () => {
        return {};
      }
    },
    textStyles: {
      type: Object,
      default: () => {
        return {};
      }
    },
    addClass: {
      type: String
    }
  },
  watch: {
    styles: {
      immediate: true,
      handler () {
        const keys = Object.keys(this.styles);
        const vals = Object.values(this.styles);
        keys.forEach((key, idx) => (this.cssString += key + ":" + vals[idx]));
        const txtkeys = Object.keys(this.textStyles);
        const txtvals = Object.values(this.textStyles);
        txtkeys.forEach((key, idx) => (this.textCssString += key + ":" + txtvals[idx]));
      }
    },
    enabledOn:{
      immediate:true,
      handler (val){
        if(!val || val ==''){
          return
        }
        return this.$store.state[val]
      }
    }
  },
  computed: {
    hasUnresolvedDependencies () {
      return this.$store.getters.hasUnresolvedDependencies(this.requires);
    }
  },
  methods: {
    async clicked () {
      if (!this.action) return;

      if(this.action.anchor){
        return window.location.href = this.$te(this.action.link) ? this.$t(this.action.link) : this.action.link
      }
      if (this.action.length > 0) {
        // console.log("inside actions loop::");
        for (let i = 0; i < this.action.length; i++) {
          const act = this.action[i];
          const fn = act.fn;
          const params = act.params;
          await this[fn](params, this);
        }
        return;
      }
      const fn = this.action.fn;
      const params = this.action.params;
      await this[fn](params, this);
      // const params = this.action.params.toString();
      // eval(`this.${this.action.fn}(params)`);
    }
  }
};
</script>

<style lang="scss" scoped>
.btn {
  &:focus,
  &:active {
    outline: none !important;
    box-shadow: none;
  }
}

.btn {
  color: #ffffff;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  user-select: none;
  background-color: transparent;
  border: 1px solid var(--brand-color);
  border-radius: var(--button-radius);
  transition: all 0.3s;
  box-sizing: border-box;
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 0.18px;
  line-height: 21px;
  text-align: center;
  padding: 15px 30px;
  text-transform: uppercase;
  width: 100%;
  max-width: 300px;
  &:hover,
      &:focus {
        box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.16) !important;
      }
      &:active {
        border-color: #DEBA06;
      }
      &-min {
        @media (max-width: 574px) {
          font-size:  17px;
        }
      }
  @media (max-width: 425.97px) {
    font-size: 13px;
    // max-width: 150px !important;
  }
  &_disabled {
    opacity: 0.2;
  }
  &-back {
    text-align: left;
    background-color: transparent;
    border: none;
    letter-spacing: 0px;
    color: var(--text-color-2);
    font-size: 16px;
    line-height: 20px;
    font-weight: normal;
    &:hover {
      text-decoration: underline;
      box-shadow: none !important;
    }
    &:focus {
      outline: 3px solid #0065D6 !important;
      outline-offset: 2px;
    }
  }
  &-next {
    background: linear-gradient(265.49deg, var(--button-gradient-2) 0%, var(--button-gradient-1) 99.55%);
    font-weight: bold;
    font-size: 18px;
    line-height: 23px;
    text-shadow: 0px 2px 4px #0154B2;
    &:disabled {
      // Prevent global disabled opacity (e.g. Bootstrap) from lowering contrast.
      opacity: 1 !important;
      background: #a2b6cd8f !important;
      color: #141414c7 !important;
      text-shadow: none;
      box-shadow: none !important;
      border: none !important
    }
    &:hover {
      background: linear-gradient(265.49deg, #0057B8 0%, #0065D6 99.55%);
    }
    &:active {
      border: 1px solid;
      border-image-source: linear-gradient(265.49deg, #0065D6 0%, #0057B8 99.55%);
    }
    &:focus {
      outline: 3px solid #0065D6 !important;
      outline-offset: 2px;
    }
  }
  .btn-text {
    text-transform: uppercase;
  }
  &-transparent {
    max-width: 350px;
    border-color: #424242;
    color: #424242;
    &:hover,
    &focus {
      background-color: #424242;
      color: #ffffff;
    }
  }
}



</style>
